import { CALENDAR_GRID_WEEK_SINGLE_LANE_COUNT } from '../../../CalendarGridWeek.constants'

export function getHasCalendarGridGroupSeveralLanes(laneCount) {
  return laneCount > CALENDAR_GRID_WEEK_SINGLE_LANE_COUNT
}

export function getIsCalendarGridTimedItemDragDisabled({
  canMoveItemsInTime,
  item,
}) {
  return !canMoveItemsInTime || !item.isTimeDraggable
}
